import React, { useEffect, useState } from "react";
import { TailSpin, ThreeDots } from "react-loader-spinner";
import BaseLayout from "../../layout/BaseLayout";
import Snackbar from "@mui/material/Snackbar";
import Pagination from "@mui/material/Pagination";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  ajoutAnneeAcademique,
  changeEtatAnneeAcademique,
  deleteAnneeAcademique,
  getListeAnneeAcademiqueDispo,
  getListeAnneeAcademiquePagination,
} from "../../services/annee-academique/AnneeAcademiqueRequest";
import { useNavigate } from "react-router-dom";

const AnneeScolaire = () => {
  const navigate = useNavigate();
  const [pageQuery, setPageQuery] = useState({
    page: 0,
    size: 7,
    nombrePage: 1,
  });
  const [loadingData, setLoadingData] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarSuccessOpen, setSnackbarOpenSuccess] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);
  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center",
  });
  const [searchLoading, setSearchLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [desactiveLoading, setDesactiveLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [anneeScolaireListe, setanneeScolaireListe] = useState([]);
  const [anneeScolaireDispoListe, setAnneeScolaireDispoListe] = useState([]);
  const [anneeScolaireInfo, setAnneeScolaireInfo] = useState(null);
  const [anneeScolaireData, setAnneeScolaireData] = useState({
    id: "",
    anneeId: "",
  });

  const { vertical, horizontal } = snackbarPosition;

  const searchAnneeScolaire = () => {
    setLoadingData(true);

    getListeAnneeAcademiquePagination(
      pageQuery.page,
      pageQuery.size,
      searchTerm
    )
      .then((res) => {
        setLoadingData(false);
        setanneeScolaireListe(res.data.donnee.etablissements);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  const modalCreateAnneeScolaire = () => {
    setAnneeScolaireInfo(null);
    setAnneeScolaireData({
      id: "",
      anneeId: "",
    });
  };

  const modalAnneeEnCours = (annee) => {
    document.getElementById("desactive-warning").click();
    setAnneeScolaireInfo(annee);
  };

  const getListeDesAnnee = () => {
    setLoadingData(true);
    getListeAnneeAcademiquePagination(0, pageQuery.size)
      .then((res) => {
        setLoadingData(false);
        setanneeScolaireListe(res.data.donnee.annees);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  const getListeDesAnneesDisponible = () => {
    getListeAnneeAcademiqueDispo()
      .then((res) => {
        setAnneeScolaireDispoListe(res.data.donnee);
      })
      .catch((err) => {
        console.log("api error", err);
      });
  };

  const ajoutNouveauNiveau = () => {
    setAddLoading(true);

    const annee = {
      id: anneeScolaireData.anneeId,
      date: "",
      fin: "",
    };

    ajoutAnneeAcademique(annee)
      .then((res) => {
        setSuccessMessage("Année academique  enregistré avec succès");
        setSnackbarOpenSuccess(true);
        setAddLoading(false);
        document.getElementById("ajout-anneScolaire").click();
        getListeDesAnnee();
        getListeDesAnneesDisponible();
      })
      .catch((err) => {
        setAddLoading(false);
        if (err && err.response) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Erreur d'enregistrement, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const supprimerNiveau = () => {
    setDeleteLoading(true);

    deleteAnneeAcademique(anneeScolaireInfo.id)
      .then((res) => {
        setSuccessMessage("Année academique supprimé avec succès");
        getListeDesAnnee();
        getListeDesAnneesDisponible();
        setSnackbarOpenSuccess(true);
        setDeleteLoading(false);
        document.getElementById("delete-warning").click();
      })
      .catch((err) => {
        setDeleteLoading(false);
        if (err.response.data) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Une erreur s'est produite, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const changerEtatAnneeScolaire = () => {
    setDesactiveLoading(true);

    if (anneeScolaireInfo.enabled) {
      changeEtatAnneeAcademique(anneeScolaireInfo.id)
        .then((res) => {
          setSuccessMessage("Année scolaire désactivée avec succès");
          getListeDesAnnee();
          setSnackbarOpenSuccess(true);
          setDesactiveLoading(false);
          document.getElementById("desactive-warning").click();
        })
        .catch((err) => {
          setDesactiveLoading(false);
          if (err.response && err.response.data) {
            setErrorMessage(err.response.data.donnee);
            setSnackbarOpenError(true);
          } else {
            setErrorMessage("Une erreur s'est produite, rééssayer!");
            setSnackbarOpenError(true);
          }
          console.log("api error", err);
        });
    } else {
      changeEtatAnneeAcademique(anneeScolaireInfo.id)
        .then((res) => {
          setSuccessMessage("Année scolaire activée avec succès");
          getListeDesAnnee();
          setSnackbarOpenSuccess(true);
          setDesactiveLoading(false);
          document.getElementById("desactive-warning").click();
        })
        .catch((err) => {
          setDesactiveLoading(false);
          if (err.response && err.response.data) {
            setErrorMessage(err.response.data.donnee);
            setSnackbarOpenError(true);
          } else {
            setErrorMessage("Une erreur s'est produite, rééssayer!");
            setSnackbarOpenError(true);
          }
          console.log("api error", err);
        });
    }
  };

  const handleCloseSnackbarSuccess = () => {
    setSnackbarOpenSuccess(false);
  };

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  const handlePaginationChange = (event, value) => {
    setLoadingData(true);
    setPageQuery((prev) => ({
      ...prev,
      page: value,
      pagePagination: value,
    }));
    if (searchTerm.length !== 0) {
      // getListeUtilisateur(value - 1, pageQuery.size)
      //   .then((res) => {
      //     setUserListe(res.data.donnee.utilisateurs);
      //     setPageQuery((prev) => ({
      //       ...prev,
      //       nombrePage: res.data.donnee.totalPages,
      //     }));
      //     setLoadingData(false);
      //   })
      //   .catch((err) => {
      //     setLoadingData(false);
      //     console.log("api error", err);
      //   });
    } else {
      // getListeUtilisateur(value - 1, pageQuery.size, searchTerm)
      //   .then((res) => {
      //     setUserListe(res.data.donnee.utilisateurs);
      //     setPageQuery((prev) => ({
      //       ...prev,
      //       nombrePage: res.data.donnee.totalPages,
      //     }));
      //     setLoadingData(false);
      //   })
      //   .catch((err) => {
      //     setLoadingData(false);
      //     console.log("api error", err);
      //   });
    }
  };

  const TableElement = ({ anneeScolaire }) => {
    return (
      <tr>
        <td className="px-4">{anneeScolaire.debut}</td>
        <td className="px-4">{anneeScolaire.fin}</td>
        <td className="w-40 px-4">
          <div className="flex items-center gap-x-3">
            <button
              className="bg-gray-100 p-1 rounded-md text-gray-700 cursor-pointer"
              onClick={() => {
                document.getElementById("delete-warning").click();
                setAnneeScolaireInfo(anneeScolaire);
              }}
            >
              <DeleteIcon />
            </button>
            <button
              className={
                anneeScolaire.etat
                  ? "bg-green-100 px-4 py-1 rounded-md font-semibold text-green-700 text-sm cursor-pointer"
                  : "bg-gray-100 px-4 py-1 rounded-md font-semibold text-gray-700 text-sm cursor-pointer"
              }
              onClick={() => modalAnneeEnCours(anneeScolaire)}
            >
              {anneeScolaire.etat ? "En cours" : "Activer"}
            </button>
          </div>
        </td>
      </tr>
    );
  };

  useEffect(() => {
    setLoadingData(true);
    getListeDesAnneesDisponible();
    getListeAnneeAcademiquePagination(pageQuery.page, pageQuery.size, "")
      .then((res) => {
        setLoadingData(false);
        setanneeScolaireListe(res.data.donnee.annees);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
        if (err.response && err.response.status === 401) {
          localStorage.removeItem("momo4scoohclient")
          navigate("/login")
        }
      });
  }, []);

  return (
    <BaseLayout>
      <div className="w-10/12 mx-auto pt-32">
        <h1 className="text-2xl text-black font-bold">
          Paramètre / Année scolaire
        </h1>
        <div className="mt-10">
          <div className="mb-5 flex items-center justify-between">
            <div>
              <p>Rechercher</p>
              <div className="flex items-center gap-x-2">
                <input
                  type="text"
                  disabled={searchLoading}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Rechercher un élément"
                  className="input input-bordered w-full max-w-xs"
                />
                <button
                  disabled={searchLoading}
                  className="w-14 h-11 bg-stone-900 text-white rounded-md flex items-center justify-center"
                  onClick={searchAnneeScolaire}
                >
                  {!searchLoading ? (
                    <SearchIcon />
                  ) : (
                    <TailSpin
                      height="25"
                      width="25"
                      color="#fff"
                      ariaLabel="tail-spin-loading"
                      radius="1"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={searchLoading}
                    />
                  )}
                </button>
              </div>
            </div>
            <label
              htmlFor="ajout-anneScolaire"
              className="bg-momo-blue text-white px-3 py-2 rounded-lg font-medium cursor-pointer"
              onClick={modalCreateAnneeScolaire}
            >
              Ajouter une année scolaire
            </label>
          </div>
          <div className="overflow-x-auto">
            <table className="table table-compact w-full mb-2">
              <thead>
                <tr>
                  <th className="capitalize py-4 px-4">Année début</th>
                  <th className="capitalize py-4 px-4">Année fin</th>
                  <th className="capitalize py-4 px-4">Actions</th>
                </tr>
              </thead>
              <tbody>
                {!loadingData && anneeScolaireListe.length > 0 ? (
                  anneeScolaireListe.map((item) => (
                    <TableElement key={item.id} anneeScolaire={item} />
                  ))
                ) : !loadingData && anneeScolaireListe.length === 0 ? (
                  <tr>
                    <td colSpan="3">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <ErrorOutlineIcon />
                        <p className="font-medium text-red-500">
                          Aucun élément trouvé
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : loadingData && anneeScolaireListe.length === 0 ? (
                  <tr>
                    <td colSpan="3">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="50"
                          width="50"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="3">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="50"
                          width="50"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="flex justify-end">
              <Pagination
                count={pageQuery.nombrePage}
                page={pageQuery.pagePagination}
                variant="outlined"
                shape="rounded"
                onChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>

      {/* MODAL AJOUT ANNEE SCOLAIRE */}
      <input type="checkbox" id="ajout-anneScolaire" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-lg">
            {anneeScolaireInfo === null
              ? "Ajouter une année scolaire"
              : "Modifier cette année scolaire"}
          </h3>
          <div className="py-4">
            <div>
              <label className="label">
                <span className="label-text">Année scolaire</span>
              </label>
              <select
                disabled={addLoading}
                value={anneeScolaireData.anneeId}
                onChange={(e) =>
                  setAnneeScolaireData((prevState) => ({
                    ...prevState,
                    anneeId: e.target.value,
                  }))
                }
                className="select select-bordered w-full font-medium"
              >
                <option value="" disabled selected>
                  Choisir une année scolaire
                </option>
                {anneeScolaireDispoListe.map((item, index) => (
                  <option value={item.id} key={index}>
                    {item.debut} - {item.fin}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="modal-action">
            {!addLoading ? (
              <label
                htmlFor="ajout-anneScolaire"
                className="bg-black text-white font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="ajout-anneScolaire"
                className="bg-black text-white font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={addLoading}
              className="bg-momo-jaune text-black font-bold px-4 py-2 rounded-md"
              onClick={ajoutNouveauNiveau}
            >
              {!addLoading ? (
                <span>{!anneeScolaireInfo ? "Enregistrer" : "Modifier"}</span>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#000"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={addLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* SUPPRIMER ANNEE SCOLAIRE */}
      <input type="checkbox" id="delete-warning" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-2xl text-center text-red-500">
            Attention !
          </h3>
          <p className="text-lg text-center py-4">
            Cette action est irréversible
          </p>
          <div className="modal-action flex justify-center gap-x-5">
            {!deleteLoading ? (
              <label
                id="delete-warning-btn"
                htmlFor="delete-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="delete-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={deleteLoading}
              className="bg-red-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
              onClick={supprimerNiveau}
            >
              {!deleteLoading ? (
                <span>Supprimer</span>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={deleteLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* DESACTIVER ANNEE SCOLAIRE */}
      <input type="checkbox" id="desactive-warning" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3
            className={
              anneeScolaireInfo && anneeScolaireInfo.etat
                ? "font-bold text-2xl text-center text-red-500"
                : "font-bold text-2xl text-center text-green-500"
            }
          >
            {anneeScolaireInfo && anneeScolaireInfo.etat
              ? "Désactiver cette année scolaire"
              : "Activer cette année scolaire"}
          </h3>
          <div className="modal-action flex justify-center gap-x-5">
            {!desactiveLoading ? (
              <label
                id="desactive-warning-btn"
                htmlFor="desactive-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="desactive-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={desactiveLoading}
              className={
                anneeScolaireInfo && anneeScolaireInfo.etat
                  ? "bg-red-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
                  : "bg-green-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
              }
              onClick={changerEtatAnneeScolaire}
            >
              {!desactiveLoading ? (
                <>
                  {anneeScolaireInfo && anneeScolaireInfo.etat ? (
                    <span>Désactiver</span>
                  ) : (
                    <span>Activer</span>
                  )}
                </>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={desactiveLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* SNACKBAR SUCCESS */}
      {successMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarSuccessOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarSuccess}
          key={vertical + horizontal}
        >
          <div className="bg-green-500 text-white px-10 py-3 rounded-lg">
            {successMessage}
          </div>
        </Snackbar>
      ) : null}

      {/* SNACKBAR ERROR */}
      {errorMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarErrorOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarError}
          key={vertical + horizontal}
        >
          <div className="bg-red-500 text-white px-10 py-3 rounded-lg">
            {errorMessage}
          </div>
        </Snackbar>
      ) : null}
    </BaseLayout>
  );
};

export default AnneeScolaire;
